import { colors, fonts } from '../../theme';

// Like the app: the game icon is 85% of the former 48px avatar (41px), the avatar 95% of the game icon (39px).
const GAME_ICON_SIZE = 41;
const AVATAR_SIZE = 39;

const button = {
  width: 48,
  height: 48,
  backgroundColor: colors.surfaceRaised,
  color: colors.text,
  '&:hover': {
    backgroundColor: colors.surfaceHover,
  },
  fontSize: 21,
};

const styles = {
  column: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    // Close to each other, like TikTok.
    gap: 1.25,
    // The game icon ends at the bottom of the info line of the player (VideoInfoLine): 18px of padding
    // + the 3px progress bar + the 10px gap above it.
    pb: '31px',
    flexShrink: 0,
  },
  action: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0.25,
    minWidth: 56,
    fontFamily: fonts.text,
    fontSize: 12,
    fontWeight: 600,
    color: colors.text,
    textAlign: 'center',
  },
  // Same height as the heart and the bubble (they fill 87.5% of their 1em box).
  bookmarkIcon: {
    fontSize: '0.875em',
  },
  // The "+" overlaps the bottom of the avatar.
  creator: {
    position: 'relative',
    mb: 1.25,
  },
  avatarButton: {
    p: 0,
  },
  avatar: {
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    border: `2px solid ${colors.text}`,
  },
  follow: {
    position: 'absolute',
    left: '50%',
    // Former 22px "+" at -10px under the 48px avatar, scaled to the 39px avatar: 18px at -8px.
    bottom: -8,
    transform: 'translateX(-50%)',
    width: 18,
    height: 18,
    p: 0,
    backgroundColor: colors.text,
    color: colors.background,
    '&:hover': {
      backgroundColor: colors.textLight,
    },
    '& svg': {
      fontSize: 13,
    },
  },
  // Under share, a bit further than the other blocks (11px instead of the 10px gap, 1.1x like the app).
  gameIcon: {
    display: 'block',
    width: GAME_ICON_SIZE,
    height: GAME_ICON_SIZE,
    mt: '1px',
    objectFit: 'contain',
  },
  button,
  buttonLiked: {
    ...button,
    color: colors.danger,
  },
  buttonFavorite: {
    ...button,
    color: colors.top,
  },
  buttonActive: {
    ...button,
    backgroundColor: colors.text,
    color: colors.background,
    '&:hover': {
      backgroundColor: colors.text,
    },
  },
};

export default styles;
